import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import './navigation.less';
import {
  Navigation,
} from 'lidya-common-components';
import {
  useNavigationLinks,
  LINKS_TO_USE_IN,
} from '../../hooks/useNavigationLinks';
import { ContextLink } from '../common/contextLink';
import { useNavButtons } from './customHooks/useNavButtons';
import { useNavLanguagePicker } from './customHooks/useNavLanguagePicker';
import { useHomeLogo } from './customHooks/useHomeLogo';

export const WebNav = ({
  noLanguageSelector, noActionsAvailable, customLinks, contextLink, CustomNavAction,
}) => {
  const { CustomHorizontalButtons, CustomVerticalButtons, VerticalMenuComplement } = useNavButtons({ noActionsAvailable, CustomNavAction });
  const LanguagePickerComponent = useNavLanguagePicker({ noLanguageSelector });
  const HomeLogo = useHomeLogo(customLinks);
  const links = useNavigationLinks({ toUseIn: LINKS_TO_USE_IN.MAIN });

  return (
    <Navigation
      CustomHorizontalButtons={() => CustomHorizontalButtons}
      CustomVerticalButtons={useMemo(() => CustomVerticalButtons, [CustomVerticalButtons])}
      VerticalMenuComplement={() => VerticalMenuComplement}
      CustomLanguagePicker={() => LanguagePickerComponent}
      CustomHomeLogo={() => HomeLogo}
      menuLinks={customLinks || links}
      CustomLink={contextLink}
    />
  );
};

WebNav.propTypes = {
  noLanguageSelector: PropTypes.bool,
  noActionsAvailable: PropTypes.bool,
  customLinks: PropTypes.arrayOf(PropTypes.shape({})),
  contextLink: PropTypes.oneOfType([PropTypes.bool, PropTypes.elementType]),
  CustomNavAction: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType]),
};

WebNav.defaultProps = {
  noLanguageSelector: false,
  noActionsAvailable: false,
  customLinks: undefined,
  contextLink: ContextLink,
  CustomNavAction: undefined,
};

export default WebNav;
